module.exports = __webpack_public_path__ + "static/step2-element@2x-38c6156c80a550d4f1e1e3832a1e57f6.png";